<template>
  <vx-card class="p-2">
    <v-select v-model="importType"  v-on:change="emitToParent" :clearable="false" :options="getOptions()" :reduce="res => res.value" name="status"/>
    <div class="flex justify-center flex-wrap mb-5 mt-2">
      <vx-tooltip :text="$t('general.download') + ' ' + $t('general.Excel-template')">
        <vs-button @click="onDownloadTemplateClick" color="primary" icon="icon-download"
                   icon-pack="feather"
                   radius size="large"
                   type="gradient">
        </vs-button>
      </vx-tooltip>
    </div>

    <div class="text-center">
      <h4>{{ $t('general.download') }}</h4>
      <p class="text-grey">{{ $t('general.excelTemplate') }}</p>
    </div>

  </vx-card>
</template>

<script>
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import { excelTemplate } from '@/constants/static-files'
export default {
  name: "CardDownloadTemplate",
  components: {
    vSelect
  },
  data () {
    return {
      importType: ''
    }
  },
  created() {
    if(this.type === 'customer') {
      this.importType = 'Borrowers'
    } else if(this.type === 'accounting') {
      this.importType = 'Contracts'
    } else if(this.type === 'custom') {
      this.importType = 'GeneratesQrCode'
    }
  },
  computed: {
    ...mapGetters({
      importCustomerTypesOptions :'Master/importCustomerTypesOptions',
      importAccountingTypesOptions :'Master/importAccountingTypesOptions',
      importCustomTypesOptions :'Master/importCustomTypesOptions',
    }),
  },
  props: {
    type: String
  },
  methods: {
    getOptions () {
      if (this.type === 'customer') {
        return this.importCustomerTypesOptions
      } else if (this.type === 'accounting') {
        return this.importAccountingTypesOptions
      } else if (this.type === 'custom') {
        return this.importCustomTypesOptions
      }
    },
    onDownloadTemplateClick() {
      if (this.importType) {
        const templateUrl = excelTemplate[this.importType]
        window.open(templateUrl, '_blank');
      }
    },
    emitToParent () {
      // console.log("a")
      // this.$emit('childToParent', this.childMessage)
    }
  }
}
</script>

<style scoped>

</style>
